export const logout = () => {
  sessionStorage.clear();
  window.location.replace("/");
};
